(function(){'use strict';
if(window.__egc)return;window.__egc=1;
function init(){
  var O='[data-egc="offers"]',F='[data-egc="fulfil"]';
  function $o(){return document.querySelector(O)}
  function $f(){return document.querySelector(F)}
  var host=$o()||$f();
  if(!host)return;
  var CUTOFF=parseInt(host.dataset.cutoff,10)||17,
      THRESH=parseInt(host.dataset.threshold,10)||349000,
      FRIDAY=5,
      cartTotal=parseInt(host.dataset.cart,10)||0;
  /* money */
  var mf=host.dataset.moneyFormat,intl;
  try{intl=new Intl.NumberFormat(host.dataset.locale||'en-EG',{style:'currency',currency:host.dataset.currency||'EGP',minimumFractionDigits:0,maximumFractionDigits:2})}
  catch(e){intl={format:function(v){return 'EGP '+(Math.round(v*100)/100)}}}
  function fmt(c){
    if(window.Shopify&&Shopify.formatMoney&&mf)return Shopify.formatMoney(c,mf).replace(/\.00$/,'');
    return intl.format(c/100);
  }
  var RTL=host.getAttribute('dir')==='rtl';
  /* N working days from today (Cairo), skipping Friday (5) and Saturday (6); returns e.g. "Thu 30 Oct" */
  function workingDaysDate(n){
    var p={};
    new Intl.DateTimeFormat('en-US',{timeZone:'Africa/Cairo',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date()).forEach(function(x){p[x.type]=x.value});
    var d=new Date(Number(p.year),Number(p.month)-1,Number(p.day),12,0,0),left=n;
    while(left>0){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==5&&w!==6)left--;}
    return new Intl.DateTimeFormat(RTL?'ar-EG':'en-GB',{weekday:'short',day:'numeric',month:'short'}).format(d);
  }
  /* monthly price tag in the theme's sticky bar */
  /* valU offer -- upcoming teaser -> live -> ended. While active, hide the Apple
     Pay row and the valU x3 row (this promo supersedes them); the header price
     stays. They return after the offer ends (30/07). */
  function valuCount(ms){
    var s=Math.floor(ms/1000),
        d=Math.floor(s/86400),h=Math.floor(s%86400/3600),m=Math.floor(s%3600/60),x=s%60,
        p=function(n){return n<10?'0'+n:n};
    return (d>0?d+(RTL?'ي ':'d '):'')+p(h)+':'+p(m)+':'+p(x);
  }
  var valuT=null;
  function valu(){
    clearInterval(valuT);
    var o=$o();
    var rows=o?o.querySelectorAll('.egc-row-apple,.egc-row-valu'):[],
        normalP=o&&o.querySelector('.egc-head-price'),
        head=o&&o.querySelector('.egc-head');
    function suppress(on){
      if(normalP)normalP.hidden=on;
      for(var i=0;i<rows.length;i++)rows[i].hidden=on;
      /* collapse the header row if nothing in it is left visible, so the card
         starts cleanly at the offers rectangle */
      if(head){
        var any=false,kids=head.children;
        for(var k=0;k<kids.length;k++){if(!kids[k].hidden){any=true;break}}
        head.hidden=!any;
      }
    }
    var box=o&&o.querySelector('[data-vpr]');
    if(!box){suppress(false);return;}
    var START=Date.parse(box.dataset.start),
        END=Date.parse(box.dataset.end),
        flag=box.querySelector('[data-vpr-flag]'),
        lbl=box.querySelector('[data-vpr-lbl]'),
        num=box.querySelector('[data-vpr-num]');
    function tick(){
      var now=Date.now();
      if(now<START){
        box.hidden=false;box.classList.remove('is-live','is-urgent');suppress(true);
        if(flag)flag.textContent=RTL?'عرض قادم':'UPCOMING DEAL';
        if(lbl)lbl.textContent=RTL?'يبدأ خلال':'starts in';
        if(num)num.textContent=valuCount(START-now);
      }else if(now<END){
        box.hidden=false;box.classList.add('is-live');
        box.classList.toggle('is-urgent',(END-now)<36e5);suppress(true);
        if(flag)flag.textContent='';
        if(lbl)lbl.textContent=RTL?'ينتهي خلال':'ends in';
        if(num)num.textContent=valuCount(END-now);
      }else{
        box.hidden=true;suppress(false);clearInterval(valuT);
      }
    }
    tick();valuT=setInterval(tick,1000);
  }
  function syncSticky(price){
    if(!price)return;
    if(document.querySelector('.egc-tru[data-hide-valu]'))return; /* valU hidden for this product (tag no-valu / no-offers) */
    var bar=document.querySelector('.product-sticky-form');
    if(!bar)return;
    var pEl=bar.querySelector('.price');
    if(!pEl)return;
    var tag=bar.querySelector('.egc-sticky-mo');
    if(!tag){
      tag=document.createElement('span');
      tag.className='egc-sticky-mo';
      pEl.appendChild(tag);
    }
    var mo=Math.ceil(price/3);
    tag.textContent=(RTL?'أو ':'or ')+fmt(mo)+(RTL?'/شهر × 3':'/mo × 3');
  }
  /* hide Add to cart + dynamic checkout (Buy it now / Apple Pay) when sold out */
  function syncBuyButtons(st){
    var hide=st==='sold_out',
        els=document.querySelectorAll('form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] button[type="submit"], .shopify-payment-button');
    for(var i=0;i<els.length;i++)els[i].style.display=hide?'none':'';
  }
  /* bottom strips: countdown / unlock bar / shipping ETA — driven by card data + live cart */
  var cdT=null,unT=null,prevBelow=null;
  function strips(fromCart){
    clearInterval(cdT);
    clearTimeout(unT);
    var o=$o(),f=$f(),h=o||f;
    if(!h)return;
    syncBuyButtons(h.dataset.status);
    if(!o)return;
    var st=o.dataset.status,
        price=parseInt(o.dataset.price,10)||0,
        eff=price+cartTotal,
        meets=st==='pickup'&&eff>=THRESH,
        below=st==='pickup'&&eff<THRESH,
        cd=o.querySelector('[data-cd]'),
        un=o.querySelector('[data-un]'),
        eta=o.querySelector('[data-eta]');
    if(cd)cd.hidden=!meets;
    if(eta){
      eta.hidden=st!=='shipping';
      /* Elite Delivery: expected date = N working days from today in Cairo time, Friday & Saturday excluded */
      var eds=document.querySelectorAll('.egc [data-eta-date]');
      for(var k=0;k<eds.length;k++){try{eds[k].textContent=workingDaysDate(parseInt(eds[k].getAttribute('data-eta-days'),10)||5);}catch(e){}}
    }
    syncSticky(price);
    if(un){
      un.classList.remove('is-done');
      un.hidden=!below;
      if(below){
        var amt=un.querySelector('[data-un-amt]'),fill=un.querySelector('[data-un-fill]');
        if(amt)amt.textContent=fmt(THRESH-eff);
        if(fill)fill.style.width=Math.min(100,Math.round(eff/THRESH*100))+'%';
      }
      /* delight: cart just pushed total over the threshold */
      if(fromCart===true&&meets&&prevBelow===true){
        un.hidden=false;
        un.classList.add('is-done');
        unT=setTimeout(function(){
          un.classList.remove('is-done');
          un.hidden=true;
        },2600);
      }
    }
    prevBelow=below;
    if(f)f.dataset.sd='0';
    if(!meets||!cd)return;
    var num=cd.querySelector('[data-cd-num]');
    function fmtHMS(ms){
      var h=Math.floor(ms/36e5),m=Math.floor(ms%36e5/6e4),s=Math.floor(ms%6e4/1e3),
          p=function(n){return n<10?'0'+n:n};
      return p(h)+':'+p(m)+':'+p(s);
    }
    function tick(){
      var now=new Date(),
          cut=new Date(now.getFullYear(),now.getMonth(),now.getDate(),CUTOFF,0,0),
          diff=cut-now;
      if(now.getDay()===FRIDAY||diff<=0){
        /* closed → overnight countdown to the next non-Friday 5PM cutoff */
        cd.classList.add('is-closed');
        cd.classList.remove('is-urgent');
        var f2=$f();
        if(f2)f2.dataset.sd='0';
        var nxt=new Date(now.getFullYear(),now.getMonth(),now.getDate(),CUTOFF,0,0);
        while(nxt-now<=0||nxt.getDay()===FRIDAY)nxt.setDate(nxt.getDate()+1);
        if(num)num.textContent=fmtHMS(nxt-now);
        return;
      }
      cd.classList.remove('is-closed');
      cd.classList.toggle('is-urgent',diff<36e5);
      var f3=$f();
      if(f3)f3.dataset.sd='1';
      if(num)num.textContent=fmtHMS(diff);
    }
    tick();
    cdT=setInterval(tick,1000);
  }
  /* cart refresh (ajax add-to-cart aware) */
  var cartRefreshTimer=null,cartRefreshPending=false,cartRefreshQueued=false;
  function scheduleCartRefresh(){
    clearTimeout(cartRefreshTimer);
    cartRefreshTimer=setTimeout(refreshCart,150);
  }
  function refreshCart(){
    if(cartRefreshPending){cartRefreshQueued=true;return;}
    cartRefreshPending=true;
    fetch('/cart.js').then(function(r){return r.ok?r.json():null}).then(function(c){
      if(c&&typeof c.total_price==='number'&&c.total_price!==cartTotal){
        cartTotal=c.total_price;
        strips(true);
      }
    }).catch(function(){}).then(function(){cartRefreshPending=false;});
  }
  var _f=window.fetch;
  window.fetch=function(input){
    var u='';
    try{u=typeof input==='string'?input:(input&&input.url)||''}catch(e){}
    var pr=_f.apply(this,arguments);
    if(/\/cart\/(add|change|update|clear)/.test(u))pr.then(function(){scheduleCartRefresh()},function(){});
    return pr;
  };
  ['cart:updated','cart:refresh','cart:change','ajaxCart:updated'].forEach(function(n){
    document.addEventListener(n,scheduleCartRefresh,{passive:true});
  });
  /* variant change → re-fetch section HTML, exactly like the original widget:
     vid comes from the URL ONLY (never from forms — pages can contain other
     /cart/add forms like sticky bars whose variant id is wrong for us).
     On variant:change we write the variant into the URL ourselves. */
  var cache=new Map(),timer=null,DEBOUNCE=300;
  function sids(){
    var s={},o=$o(),f=$f();
    if(o&&o.dataset.sid)s[o.dataset.sid]=1;
    if(f&&f.dataset.sid)s[f.dataset.sid]=1;
    return Object.keys(s);
  }
  function gallerySig(g){
    var s='',els=g.querySelectorAll('[data-media-id]');
    for(var i=0;i<els.length;i++)s+=els[i].getAttribute('data-media-id')+'|'+(els[i].className||'')+';';
    return s;
  }
  /* Pickup accuracy: Shopify's bulk store_availabilities over-reports pickup (a
     branch shows "available" when the item is in stock at ANY location, e.g. the
     Dubai warehouse). Re-verify each branch via Shopify's per-variant endpoint —
     the same source the theme's native pickup component uses — and show a branch
     only when it truly holds the item. */
  var pickCache={};
  /* Shopify shows a branch's configured pickup time (e.g. "1 hour" / "2 hours")
     when the item is physically there, but a long default ("24 hours") when the
     branch only has it via transfer from another location. Parse the hours so we
     can exclude transfer-only branches. */
  function readyHours(txt){
    var d=(txt||'').replace(/[\u0660-\u0669]/g,function(c){return c.charCodeAt(0)-0x0660;})
                   .replace(/[\u06F0-\u06F9]/g,function(c){return c.charCodeAt(0)-0x06F0;});
    var m=d.match(/(\d+)\s*([A-Za-z\u0600-\u06FF]+)/);
    if(!m)return 0;
    var n=parseInt(m[1],10)||0;
    if(/day|days|\u064A\u0648\u0645|\u0623\u064A\u0627\u0645|week/i.test(m[2]))n*=24;
    return n;
  }
  function applyPickup(vid,html){
    var cur=document.querySelector(F);
    if(!cur||cur.getAttribute('data-vid')!==vid||cur.getAttribute('data-status')!=='pickup')return;
    var doc;try{doc=new DOMParser().parseFromString(html,'text/html');}catch(e){return;}
    var items=doc.querySelectorAll('.pickup-availability-list__item'),avail=[],i;
    for(i=0;i<items.length;i++){
      var h=items[i].querySelector('h4'),nm=h?h.textContent.trim():'';
      if(!/cairo|zayed|sodic/i.test(nm))continue;
      var svg=items[i].querySelector('.pickup-availability-info svg');
      if(!(svg&&/check-circle/.test(svg.getAttribute('class')||'')))continue;
      var pp=items[i].querySelector('.pickup-availability-info p');
      if(readyHours(pp?pp.textContent:'')>=12)continue; /* transfer-only, not physically here */
      avail.push(nm);
    }
    var loc=cur.querySelector('[data-loc]');
    if(avail.length>0){ if(loc)loc.textContent=avail.join(' \u00B7 '); }
    else{
      cur.setAttribute('data-status',cur.getAttribute('data-fallback')||'shipping');
      var cd=document.querySelector('[data-cd]');if(cd)cd.hidden=true;
      var un=document.querySelector('[data-un]');if(un)un.hidden=true;
    }
  }
  function fixPickup(){
    var f=document.querySelector(F);
    if(!f||f.getAttribute('data-status')!=='pickup')return;
    var vid=f.getAttribute('data-vid');if(!vid)return;
    if(pickCache[vid]!==undefined){applyPickup(vid,pickCache[vid]);return;}
    var root=f.getAttribute('data-root')||'/';
    if(root.charAt(root.length-1)!=='/')root+='/';
    fetch(root+'variants/'+vid+'/?section_id=pickup-availability')
      .then(function(r){return r.ok?r.text():null;})
      .then(function(t){if(t==null)return;pickCache[vid]=t;applyPickup(vid,t);})
      .catch(function(){});
  }
  function swap(html){
    var doc=new DOMParser().parseFromString(html,'text/html');
    [O,F].forEach(function(sel){
      var nw=doc.querySelector(sel),old=document.querySelector(sel);
      if(nw&&old)old.replaceWith(nw);
    });
    /* media gallery: the theme shows/hides variant media server-side, so
       re-render it from the fetched section when its content differs —
       this is what makes the matching variant image appear */
    try{
      var fg=doc.querySelector('media-gallery'),lg=document.querySelector('media-gallery');
      if(fg&&lg&&gallerySig(fg)!==gallerySig(lg))lg.replaceWith(fg);
    }catch(err){}
    reorderPicker();
    valu();
    fixPickup();
  }
  /* ── stock-aware swatch ordering: Cairo pickup → UAE shipping → sold out ──
     statuses are learned from idle-time prefetch of each variant's section
     (which also pre-warms the cache, making variant clicks instant) */
  var statusByVid={};
  function rankOf(b){
    var st=statusByVid[String(b.dataset.vid||'')];
    if(st==='pickup')return 0;
    if(st==='shipping')return 1;
    if(st==='sold_out')return 2;
    if(b.classList.contains('is-disabled'))return 3;
    if(b.classList.contains('is-oos'))return 2;
    return 1;
  }
  function reorderPicker(){
    var o=$o();
    if(!o)return;
    var rows=o.querySelectorAll('.egc-vp-vals');
    for(var ri=0;ri<rows.length;ri++){
      var row=rows[ri],
          btns=[].slice.call(row.querySelectorAll('.egc-vp-v'));
      if(btns.length<2)continue;
      var ranked=btns.map(function(b,i){return {b:b,r:rankOf(b),i:i}});
      ranked.sort(function(a,c){return a.r-c.r||a.i-c.i});
      var changed=false;
      for(var k=0;k<ranked.length;k++){if(ranked[k].b!==btns[k]){changed=true;break}}
      if(changed)for(var m=0;m<ranked.length;m++)row.appendChild(ranked[m].b);
    }
  }
  function dim(on){
    [$o(),$f()].forEach(function(el){
      if(el)el.style.opacity=on?'0.45':'';
    });
  }
  function fetchSection(vid,sid){
    var key=location.pathname+':'+vid+':'+sid;
    if(cache.has(key))return Promise.resolve(cache.get(key));
    return fetch(location.pathname+'?variant='+vid+'&section_id='+sid,{headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){if(!r.ok)throw new Error(r.status);return r.text()})
      .then(function(t){
        cache.set(key,t);
        if(cache.size>30){cache.delete(cache.keys().next().value)}
        return t;
      });
  }
  function update(){
    var w=$o()||$f();
    if(!w)return;
    var vid=new URLSearchParams(location.search).get('variant');
    if(!vid||w.dataset.vid===vid)return;
    var ids=sids();
    if(!ids.length)return;
    dim(true);
    var done=0;
    ids.forEach(function(sid){
      fetchSection(vid,sid).then(function(t){
        swap(t);
        done++;
        if(done===ids.length){
          var no=$o();
          if(no&&no.dataset.cart)cartTotal=parseInt(no.dataset.cart,10)||cartTotal;
          strips();
        }
      }).catch(function(err){
        if(window.console)console.error('[EGC]',err);
        dim(false);
      });
    });
  }
  function refresh(){
    clearTimeout(timer);
    timer=setTimeout(update,DEBOUNCE);
  }
  /* theme variant events → write variant into URL (refresh fires via history patch) */
  /* instant valU monthly refresh on variant change (section refetch reconciles) */
  var VPRICES={};
  try{(JSON.parse((document.querySelector('[data-egc-vprices]')||{}).textContent||'[]')||[]).forEach(function(p){VPRICES[p[0]]=p[1]})}catch(e){}
  function setValuPrices(price){
    price=parseInt(price,10);
    if(!price)return;
    var o=$o();if(!o)return;
    var mo=Math.ceil(price/3),
        cash=Math.round(price*0.88),
        apcf=(100-(parseInt(o.getAttribute('data-apple-pct'),10)||5))/100,
        apple=Math.round(price*apcf),i,els;
    els=o.querySelectorAll('[data-tru-mo]');for(i=0;i<els.length;i++)els[i].textContent=fmt(mo);
    els=o.querySelectorAll('[data-p]');for(i=0;i<els.length;i++)els[i].textContent=fmt(price);
    els=o.querySelectorAll('[data-cash]');for(i=0;i<els.length;i++)els[i].textContent=fmt(cash);
    els=o.querySelectorAll('[data-apple]');for(i=0;i<els.length;i++)els[i].textContent=fmt(apple);
  }
  document.addEventListener('variant:change',function(e){
    if(e.detail&&e.detail.variant&&e.detail.variant.id){
      setValuPrices(VPRICES[e.detail.variant.id]);
      var u=new URL(location);
      u.searchParams.set('variant',e.detail.variant.id);
      history.replaceState({},'',u);
      refresh();
    }
  },{passive:true});
  document.addEventListener('variantChange',function(){refresh()},{passive:true});
  var _p=history.pushState,_r=history.replaceState;
  history.pushState=function(){_p.apply(this,arguments);refresh()};
  history.replaceState=function(){_r.apply(this,arguments);refresh()};
  window.addEventListener('popstate',refresh,{passive:true});
  document.addEventListener('shopify:section:load',refresh,{passive:true});
  /* widget variant picker — prefer the theme's native radios so its gallery,
     form and URL all update; fall back to form-id + URL if no radio found */
  document.addEventListener('click',function(e){
    var b=e.target&&e.target.closest&&e.target.closest('.egc-vp-v');
    if(!b||b.classList.contains('is-disabled')||b.classList.contains('is-on'))return;
    var optEl=b.closest('.egc-vp-opt'),
        optName=(optEl&&optEl.dataset.optName)||'',
        val=b.dataset.val||'',
        vid=b.dataset.vid||'';
    var wrap=b.closest('.egc-vp-vals');
    if(wrap){
      var sib=wrap.querySelectorAll('.egc-vp-v');
      for(var i=0;i<sib.length;i++)sib[i].classList.remove('is-on');
      b.classList.add('is-on');
    }
    if(vid)setValuPrices(VPRICES[vid]);
    /* sparse matrix jump: this value needs the OTHER option(s) to change too, so a
       single native-radio click can't express it — jump straight to the resolved
       variant by id (URL + form id + section refetch keep everything in sync). */
    if(b.dataset.jump&&vid){
      var jels=document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
      for(var jk=0;jk<jels.length;jk++){jels[jk].value=vid;jels[jk].dispatchEvent(new Event('change',{bubbles:true}));}
      var ju=new URL(location);ju.searchParams.set('variant',vid);history.replaceState({},'',ju);
      refresh();
      return;
    }
    var radios=document.querySelectorAll('variant-picker input[type="radio"], variant-radios input[type="radio"], .product-form__input input[type="radio"]'),hit=null;
    for(var j=0;j<radios.length;j++){
      var r=radios[j];
      if(r.value===val&&optName&&r.name.indexOf(optName)===0){hit=r;break}
    }
    if(hit){
      if(!hit.checked)hit.click();
      return;
    }
    if(!vid)return;
    var els=document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
    for(var k=0;k<els.length;k++){
      els[k].value=vid;
      els[k].dispatchEvent(new Event('change',{bubbles:true}));
    }
    var u=new URL(location);
    u.searchParams.set('variant',vid);
    history.replaceState({},'',u);
    refresh();
  },{passive:true});
  /* keep Intercom above the sticky bar on mobile (official setting + CSS fallback) */
  try{
    if(matchMedia('(max-width:768px)').matches){
      window.intercomSettings=window.intercomSettings||{};
      window.intercomSettings.vertical_padding=100;
      if(typeof window.Intercom==='function')window.Intercom('update',{vertical_padding:100});
    }
  }catch(e){}
  strips();
  valu();
  reorderPicker();
  fixPickup();

}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}
else{setTimeout(init,1)}
})();
